import { Box, Button } from "@mui/material";
import React from "react";

const Home = (propse) => {
  return (
    <React.Fragment>
      <Box sx={{ width: "90%" }}>
        <Box
          sx={{
            fontFamily: "Aboreto",
            fontSize:
              propse.Width >= 560 && propse.Width < 768 ? "0.9rem" : "1rem",
            marginLeft:
              propse.Width >= 560 && propse.Width < 768 ? "10px" : "40px",
          }}
        >
          you know about
        </Box>
        <Box
          sx={{
            fontFamily: "Aboreto",
            fontSize:
              propse.Width >= 560 && propse.Width < 768 ? "1.5rem" : "1.9rem",
            marginTopp:
              propse.Width >= 560 && propse.Width < 768 ? "-10px" : "-10px",
          }}
        >
          LEITNER BOX
        </Box>
        <Box
          sx={{
            fontFamily: "Outfit",
            fontSize: "0.8rem",
            color: "rgba(0,0,0,0.7)",
            textAlign: "justify",
            marginTop: "20px",
          }}
        >
          <Box sx={{ marginTop: "0px" }}>
            The Leitner Box is a study aid or flashcard system used to help
            learners efficiently memorize information. It was developed by
            German psychologist Sebastian Leitner in the 1970s.
          </Box>
          <Box sx={{ marginTop: "10px" }}>
            The Leitner Box consists of a set of index cards or flashcards, each
            with a question or piece of information on one side and the answer
            on the other. The cards are divided into several boxes, typically
            four or five, labeled with increasing levels of difficulty. To use
            the Leitner Box system, learners start by reviewing the cards in the
            first box. If they answer a question correctly, the card is moved to
            the next box.
          </Box>
          <Box sx={{ marginTop: "10px" }}>
            If they answer incorrectly, the card is returned to the first box.
            Cards in the higher boxes are reviewed less frequently, as the
            assumption is that the learner has already memorized the
            information.
          </Box>
          <Box sx={{ marginTop: "10px" }}>
            The Leitner Box system is based on the principle of spaced
            repetition, which is the idea that we are more likely to remember
            information if we review it at intervals spaced out over time,
            rather than trying to cram it all in at once. This makes it an
            effective study tool for learners of all ages and levels
          </Box>
        </Box>
        <Box>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#ed013e",
              width: propse.Width < 560 ? "100%" : "150px",
              height: "45px",
              fontFamily: "Poppins",
              fontSize: "0.8rem",
              fontWeight: "bold",
              zIndex: "6",
              marginTop: "46px",
              display: propse.Width < 560 ? "none" : "flex",
            }}
            onMouseEnter={(e) => (e.target.style.backgroundColor = "#ed013e")}
            onMouseLeave={(e) => (e.target.style.backgroundColor = "#ed013e")}
          >
            SHOW MORE
          </Button>
        </Box>
      </Box>
    </React.Fragment>
  );
};

export default Home;
